import type { PlanTier } from '@/actions/settings/billingActions'

export const SIGNUP_CADENCES = { month: 'month', year: 'year' } as const

export type SignupCadence =
  (typeof SIGNUP_CADENCES)[keyof typeof SIGNUP_CADENCES]

export type SignupPlanPrice = {
  priceId: string
  unitAmountInCents: number | null
}

/** Mirrors the API `Plan`; `tier` stays a string so an unknown tier drops a card. */
export type SignupPlan = {
  tier: string
  productId: string
  displayName: string
  prices: Partial<Record<SignupCadence, SignupPlanPrice>>
}

/** A legacy plan's cadences come from different products, so each keeps its own id. */
export type CadencePrice = SignupPlanPrice & { productId: string }

export type SignupCard = {
  tier: PlanTier
  productId: string
  displayName: string
  prices: Partial<Record<SignupCadence, CadencePrice>>
}

export type CheckoutSelection = { priceId: string; productId?: string }
